module.exports = __webpack_public_path__ + "img/FB_Info_Game_Page_7-2.fa4394d8.png";